import './Pill.css';

import Card from 'react-bootstrap/Card';
import { ReactComponent as EditIcon } from 'assets/icons/edit_icon.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close_icon.svg';

function Pill({ children, editAction, objectToEdit, closeAction, isLocked = false }) {
    return (
        <Card
            className={`d-flex flex-row justify-content-between p-2 mb-2 ${isLocked && 'locked'}`}
        >
            {editAction && !isLocked ? (
                <EditIcon
                    onClick={editAction ? () => editAction(objectToEdit) : null}
                    role="button"
                />
            ) : (
                <span></span>
            )}
            {children}
            {closeAction && !isLocked ? (
                <CloseIcon onClick={closeAction ? () => closeAction() : null} role="button" />
            ) : (
                <span></span>
            )}
        </Card>
    );
}

export default Pill;
